import React from "react";
import Navbar from "../components/Navbar";

import Footer from "../components/Footer";
import ImageCarousel from "../components/Carousel";
import ProjectCard from "../components/ProjectCard";
import ProjectDesciption from "../components/ProjectDescription";

const Project1 = () => {
    const carouselImages = [
        {
          src: "./Semester_4/Modellfoto_Weber_Vivienne.webp",
          alt: "Model",
          text: "Model Oblique View"
        },
        {
          src: "./Semester_4/1.webp",
          alt: "Mountains",
          text: "Overview Nairs"
        },
        
      ];

    const title = "Revitalisation of the Post Office Building";
    const subtitle = "The Transit Building Nairs";
    const description = "Nairs is a now outdated and partly neglected complex located just outside the alpine village of Scuol. It includes the Büvetta drinking hall, the Chasa Carola with a mineral spring, the spa hotel, a nursery, a bathhouse and an old post office building. New objectives for the complex were defined as part of a group project and the concept of a lively interface was further developed. Each building was assigned to one person for further development, with the redesign of the post office building taking centre stage below.";
    const secondDescription = "The new Nairs sports and cultural centre in the Lower Engadine lacks a central arrival area. The current positioning of the bus stop is unclear and inappropriate. The cantonal road, which runs above the former post office building, separates the nursery from the rest of the site. The location of the post office building is therefore ideal for multifunctional use, including a waiting area for the bus stop, an information centre for the site, a shop area and a link to the nursery.";
    const thirdDescription = "The street level will be made accessible by adding a storey, allowing the bus stop to be moved upwards. A bridge over the cantonal road connects the nursery with the rest of the complex. The aim of the conversion is to create a permanently accessible building that allows continuous accessibility through arcades, and the aesthetics of the intervention are based on an analysis of the load-bearing system. The dimensions of the rooms on the first floor are based on these findings, which are also reflected in the column pattern in the exterior space. The new building follows a clear, logical development of the existing building."
    const map = "./Semester_4/GraubündenKarte.webp";
    const semester = "Springsemester 2024";
    const professosr = "4th semester at Boltshauser";
    const tools = "created with ArchiCAD, Cinema 4D, Midjourney, Photoshop";
    const coAuthor = "";

    const cards = [
      {
        id: 1,
        content: <p>Visualisation of the renovated post office building.</p>,
        className: "h-40 bg-blue-500",
        thumbnail: "./Semester_4/2.0.webp",
      },
      {
        id: 2,
        content: <p>Ground floor with Kiosk store and herb sale supporting local garden centre.</p>,
        className: "h-40 bg-red-500",
        thumbnail: "./Semester_4/2.1.webp",
      },
      {
        id: 3,
        content: <p>Ground floor demolition and new construction plan.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/2.2.webp",
      },
      {
        id: 4,
        content: <p>First floor houses administration rooms which are accessible through the arcade.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/3.1.webp",
      },
      {
        id: 5,
        content: <p>First floor demolition and new construction plan.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/3.2.webp",
      },
      {
        id: 6,
        content: <p>The second floor is almost entirely open and consists of the bus waiting area in the middle and an information centre of the entire complex of Nairs.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/4.1.webp",
      },
      {
        id: 7,
        content: <p>Second floor demolition and new construction plan.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/4.2.webp",
      },
      {
        id: 8,
        content: <p>The Building is connected to the garden centre via a bridge over the street. The additional storey is kept light and built in wood.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/5.webp",
      },
      {
        id: 9,
        content: <p>Frontal view of the old postal office.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/6.webp",
      },
      {
        id: 10,
        content: <p>Zoom in axonometry of the first floor new façade in wood and the floor.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/7.webp",
      },
      {
        id: 11,
        content: <p>AI generated bus waiting area reference.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/8.webp",
      },
      {
        id: 12,
        content: <p>AI generated bus waiting area reference.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/9.webp",
      },
      {
        id: 13,
        content: <p>The bus waiting area is adorned with benches. The slats create the illusion of a closed room while the sun proves the permeability of the façade.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_4/10.webp",
      },
   
    ];
    
  return (
    <>
    <div className="pb-25 flex items-center justify-center bg-[#e7e5e4]">
        <Navbar />
    </div>
    
      <ImageCarousel images={carouselImages} title={title} />
      <ProjectDesciption subtitle={subtitle} description={description} secondDescription={secondDescription} thirdDescription={thirdDescription} map={map} semester={semester} professor={professosr} tools={tools} coAuthor={coAuthor}/>
      <ProjectCard cards={cards}/>
      <Footer />
    </>
  );
};

export default Project1;

